// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.m-comment__text{\n  overflow: hidden!important;\n  text-overflow: ellipsis!important;\n}\n", ""]);
// Exports
module.exports = exports;
